"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveFieldType = exports.resolveKey = exports.resolveId = exports.resolveField = exports.datasetsBySchema = exports.datasetByName = exports.datasets = void 0;
const affiliation_1 = require("./schemas/affiliation");
const apm_1 = require("./schemas/apm");
const facility_1 = require("./schemas/facility");
const hcindex_1 = require("./schemas/hcindex");
const hha_1 = require("./schemas/hha");
const hospice_1 = require("./schemas/hospice");
const hospital_1 = require("./schemas/hospital");
const mdm_1 = require("./schemas/mdm");
const provider_1 = require("./schemas/provider");
const general_1 = require("./schemas/general");
const geo_1 = require("./schemas/geo");
const geo_benchmark_1 = require("./schemas/geo-benchmark");
const pophealth_1 = require("./schemas/pophealth");
const grumpy_cloud_1 = require("./schemas/grumpy-cloud");
const resolve_1 = require("./util/resolve");
Object.defineProperty(exports, "resolveFieldType", { enumerable: true, get: function () { return resolve_1.resolveFieldType; } });
Object.defineProperty(exports, "resolveKey", { enumerable: true, get: function () { return resolve_1.resolveKey; } });
Object.defineProperty(exports, "resolveId", { enumerable: true, get: function () { return resolve_1.resolveId; } });
Object.defineProperty(exports, "resolveField", { enumerable: true, get: function () { return resolve_1.resolveField; } });
const clinical_1 = require("./schemas/clinical");
const payer_1 = require("./schemas/payer");
const nursing_1 = require("./schemas/nursing");
const pt_1 = require("./schemas/pt");
const ref_1 = require("./schemas/ref");
const orgs_1 = require("./schemas/orgs");
const code_1 = require("./schemas/code");
const panel_1 = require("./schemas/panel");
const journey_1 = require("./schemas/journey");
const datasets = [
    ...affiliation_1.default,
    ...apm_1.default,
    ...clinical_1.default,
    ...facility_1.default,
    ...general_1.default,
    ...geo_1.default,
    ...geo_benchmark_1.default,
    ...hcindex_1.default,
    ...hha_1.default,
    ...nursing_1.default,
    ...hospice_1.default,
    ...hospital_1.default,
    ...payer_1.default,
    ...pophealth_1.default,
    ...provider_1.default,
    ...pt_1.default,
    ...ref_1.default,
    ...orgs_1.default,
    ...code_1.default,
    ...panel_1.default,
    ...journey_1.default,
    // Include other databases
    ...mdm_1.default,
    ...grumpy_cloud_1.default,
];
exports.datasets = datasets;
const datasetByName = {};
exports.datasetByName = datasetByName;
function addDataset(name, dataset) {
    if (datasetByName[name])
        throw new Error('Duplicate dataset names: ' + name);
    datasetByName[name] = dataset;
}
datasets.forEach(dataset => {
    addDataset(dataset.name, dataset);
    if (dataset.altName)
        addDataset(dataset.altName, dataset);
});
const datasetsBySchema = {
    affiliation: affiliation_1.default,
    apm: apm_1.default,
    clinical: clinical_1.default,
    facility: facility_1.default,
    general: general_1.default,
    geo: [...geo_1.default, ...geo_benchmark_1.default],
    hcindex: hcindex_1.default,
    hha: hha_1.default,
    hospice: hospice_1.default,
    hospital: hospital_1.default,
    mdm: mdm_1.default,
    payer: payer_1.default,
    pophealth: pophealth_1.default,
    provider: provider_1.default,
    nursing: nursing_1.default,
    pt: pt_1.default,
    ref: ref_1.default,
    orgs: orgs_1.default,
    code: code_1.default,
    panel: panel_1.default,
    journey: journey_1.default
};
exports.datasetsBySchema = datasetsBySchema;
